<div #embedContainer class="gitbook-embed-container">
    <!-- O script será injetado aqui -->
</div>
